import {
  getMethodologyDeepComponentDeep,
  getUsedIdsInMethodology,
  createComponentDeepFromPhenomenonTree,
  getAvailableComponentsFromPhenomenon
} from '../../redux/methodologyDeep/services';
import { cloneDeep } from 'lodash';
import { MethodologyDeep } from '../../redux/methodologyDeep/models';
import { Phenomenon, UUID } from '../../redux/models';

export function getUsedCharacteristicsComponentsFromPhenomenon(
  methodologyDeep: MethodologyDeep,
  selectedPhenomenonId: UUID,
  phenomenaTree: Phenomenon[]
) {
  let newPhenomenon = getAvailableComponentsFromPhenomenon(methodologyDeep, selectedPhenomenonId, phenomenaTree);

  newPhenomenon = filterComponentsInMethodologyOnlyWithUsedCharacteristics(methodologyDeep, newPhenomenon);

  return createComponentDeepFromPhenomenonTree(newPhenomenon);
}

export function filterComponentsInMethodologyOnlyWithUsedCharacteristics(methodologyDeep: MethodologyDeep, selectedPhenomenon: Phenomenon) {
  if (
    !selectedPhenomenon ||
    !methodologyDeep ||
    !methodologyDeep.inspectionLayout ||
    !methodologyDeep.inspectionLayout.inspectionGroups ||
    methodologyDeep.inspectionLayout.inspectionGroups.length === 0
  )
    return selectedPhenomenon;

  const componentDeeps = getMethodologyDeepComponentDeep(methodologyDeep);

  const phenomenon = cloneDeep(selectedPhenomenon);

  const { usedCharacteristicIds, usedCharacteristicIdsAsAliases, usedIndicatorIds } = getUsedIdsInMethodology(componentDeeps);

  if (phenomenon.characteristics) {
    const usedCharacteristicsAndAliasesIds = [...usedCharacteristicIds, ...usedCharacteristicIdsAsAliases];
    phenomenon.characteristics = phenomenon.characteristics.filter(
      characteristic => characteristic.id && usedCharacteristicsAndAliasesIds.includes(characteristic.id)
    );
  }

  if (phenomenon.indicators)
    phenomenon.indicators = phenomenon.indicators.filter(indicator => indicator.id && usedIndicatorIds.includes(indicator.id));

  return phenomenon;
}

export function getCurrentCharacteristicsComponentsInPhenomenonFromMethodologyDeep(
  methodologyDeep: MethodologyDeep,
  phenomenonId: UUID,
  id: UUID
) {
  if (!methodologyDeep || !phenomenonId || !id) return [];

  const currentPhenomenon = methodologyDeep?.inspectionLayout?.inspectionGroups
    .flatMap(group => group.categories)
    .flatMap(category => category?.phenomenons)
    .find(phenomenon => phenomenon?.id === id && phenomenon.phenomenonId === phenomenonId);
  const characteristics = currentPhenomenon?.components?.filter(component => component.characteristic) || [];

  return characteristics;
}
